import { grep } from "jquery";

export function tools() {
    new Swiper('.tools-swiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            650: {
                slidesPerView: 3,
                grid: {
                    fill: 'row',
                    rows: 3,
                },
            }
        }
    });
}
